import store from '@/store';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import {
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import Select2Multiple from 'v-select2-multiple-component';
import Footer from "@/components/layout/admin/FooterPage.vue";
import axios from 'axios';

export default {
  name: "LoginPage",

  components: {
    Footer,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      loginForm: {
        campus_id: 0,
        loginId: "",
        password: "",
        status: "admin"
      },
      campusArr: [],
      submitted: false,
      validation_error: false,
      error: "",
      isLoading: false,
      disabled: false,
    };
  },

  validations: {
    loginForm: {
      campus_id: {
        required
      },
      loginId: {
        required
      },
      password: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(8)
      },
    },
  },

  methods: {
    getLoginStatus() {
      const isTeacherLoginId = this.loginForm.loginId.trim().toUpperCase().startsWith("T");
      return isTeacherLoginId ? "teacher" : "admin";
    },

    redirectAfterLogin() {
      if (this.$store.state.user.teacher_no) {
        window.location.replace("/teacher/dashboard");
        return;
      }

      let adminNo = this.$store.state.user.admin_no;
      if (adminNo == '0001') {
        window.location.replace('/employee/list');
      } else if (this.$store.state.user.role ==  CONFIG.ROLE.ID.LIBRARY_ADMIN) {
        window.location.replace('/library/category');
      } else if (this.$store.state.user.role == CONFIG.ROLE.ID.CLASS_MONITOR) {
        window.location.replace('/attendanceStudent/list')
      } else {
        window.location.replace('/');
      }
    },

    campusNameAction() {
      axios.get('campus/loginCampus')
        .then(res => {
          this.isLoading = false;
          this.campusArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    idWithCampus() {
      if (this.loginForm.loginId === '0001') {
        this.loginForm.campus_id = 1;
      }
    },

    submitLogin() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }

      this.loginForm.status = this.getLoginStatus();

      this.disabled = true;

      store.dispatch("login", this.loginForm)
        .then(() => {
          this.redirectAfterLogin();
                    this.$notification.success('success', {
                timer: 3,
                position: "bottomCenter"
              });
        })
        .catch((error) => {
          this.isLoading = false;
          this.disabled = false;

          const status = error.response?.status;
          const message = error.response?.data?.message;

          if (status == 401) {
            if (message == CONFIG.LOGIN_NOT_ALLOW) {
              this.$notification.error(message, {
                timer: 3,
                position: "bottomCenter"
              });
            } else {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            return;
          }

          this.validation_error = true;
          if (error.response?.data?.status == 400) {
            this.error = message;
          } else {
            this.error = "Incorrect Login Number or Password";
          }

          this.$notification.error(this.error, {
            timer: 3,
            position: "bottomCenter"
          });
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.campusNameAction();
  },
};
